module.exports = __webpack_public_path__ + "static/media/x.b0200bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal.v2/x.svg
// module id = 157
// module chunks = 0